import {
    FunctionComponent,
    useContext,
} from "react";
import { UserContext } from "components/user";
import { PageLayout, Wrapper } from "components/layout";
import { UserNeedsAuthentication } from "components/user";
import { Text, Title } from "components/text";
import { JiraBugCollector } from "components/jiraBugCollector";
import { Column, Row } from "components/structure";
import { Button } from "@mui/material";
import { Article } from "@mui/icons-material";

const HelpPage: FunctionComponent = () => {
    const { authenticated } = useContext(UserContext);

    return (
        <PageLayout header footer>
            <Wrapper>
                {authenticated ? (
                    <Column style={{gap: "1em"}}>
                        
                        <Row>
                            <Column>
                                <Title level={2} size="medium">Learn</Title>
                                <Text>
                                    <Button 
                                    variant='contained' 
                                    href="https://docs.contextualize.us.com/collections/overview/" 
                                    target="_blank"
                                    startIcon={<Article/>}>
                                        Documentation
                                    </Button>
                                </Text>
                            </Column>
                        </Row>
                        <Row>
                            <Column>
                                <Title level={2} size="medium">Support</Title>
                                <Text>
                                    If you need to create a new form template or edit an existing form,
                                    please contact <a href='mailto: lindsey.kuettner@contextualize.us.com'>Lindsey</a>.
                                </Text>
                                <div style={{marginTop: '0.5em'}}><JiraBugCollector variant="contained"/></div>
                            </Column>
                        </Row>
                    </Column>
                ) : (
                    <UserNeedsAuthentication />
                )}
            </Wrapper>
        </PageLayout>
    );
};

export default HelpPage;
